// extracted by mini-css-extract-plugin
export default {"button":"Button_button__UPJW-","primary":"Button_primary__7S3AZ","padding":"Button_padding__TuahJ","secondary":"Button_secondary__DsTg-","text":"Button_text__LKB-e"};